// Valid MTO options (5 MTOs - MoneyGram removed)
export const VALID_MTOS = [
  'GTBank Ghana',
  'First Bank Nigeria',
  'Zenith Bank Nigeria',
  'Stanbic Uganda',
  'KCB Kenya',
  'Paga Ghana',
  'Flutterwave Nigeria',
  'M-Pesa Kenya',
  'Airtel Money Uganda',
  'Orange Money Senegal',
  'MoneyGram Ghana',
  'Western Union Nigeria',
  'WorldRemit Uganda',
  'Wise Kenya',
  'Remitly Senegal',
] as const

export type ValidMTO = (typeof VALID_MTOS)[number]

// Valid Sub-Agent options
export const VALID_SUB_AGENTS = [
  // IMTO Agents
  'Paga Ghana',
  'MoneyGram Nigeria',
  'WorldRemit Kenya',
  // Fintech Agents
  'Flutterwave Ghana',
  'Flutterwave Nigeria',
  'M-Pesa Kenya',
  'Orange Money Senegal',
  // Cash Agents
  'Accra Money Center',
  'Lagos Express',
  'Nairobi Remit Center',
] as const

export type ValidSubAgent = (typeof VALID_SUB_AGENTS)[number]

// Helper function to validate MTO
export const isValidMTO = (mto: string): mto is ValidMTO => {
  return VALID_MTOS.includes(mto as ValidMTO)
}

// Helper function to validate Sub-Agent
export const isValidSubAgent = (
  subAgent: string,
): subAgent is ValidSubAgent => {
  return VALID_SUB_AGENTS.includes(subAgent as ValidSubAgent)
}

// Helper function to get nearest valid MTO (for migration/cleanup)
export const getNearestValidMTO = (mto: string): ValidMTO => {
  const lowerMTO = mto.toLowerCase()

  if (lowerMTO.includes('gtbank')) return 'GTBank Ghana'
  if (lowerMTO.includes('first bank')) return 'First Bank Nigeria'
  if (lowerMTO.includes('zenith')) return 'Zenith Bank Nigeria'
  if (lowerMTO.includes('stanbic')) return 'Stanbic Uganda'
  if (lowerMTO.includes('kcb')) return 'KCB Kenya'
  if (lowerMTO.includes('paga')) return 'Paga Ghana'
  if (lowerMTO.includes('flutterwave')) return 'Flutterwave Nigeria'
  if (lowerMTO.includes('mpesa') || lowerMTO.includes('m-pesa'))
    return 'M-Pesa Kenya'
  if (lowerMTO.includes('airtel')) return 'Airtel Money Uganda'
  if (lowerMTO.includes('orange')) return 'Orange Money Senegal'
  if (lowerMTO.includes('moneygram')) return 'MoneyGram Ghana'
  if (lowerMTO.includes('western')) return 'Western Union Nigeria'
  if (lowerMTO.includes('worldremit')) return 'WorldRemit Uganda'
  if (lowerMTO.includes('wise')) return 'Wise Kenya'
  if (lowerMTO.includes('remitly')) return 'Remitly Senegal'

  // Default to first option if no match
  return VALID_MTOS[0]
}

// Helper function to get nearest valid Sub-Agent (for migration/cleanup)
export const getNearestValidSubAgent = (subAgent: string): ValidSubAgent => {
  const lowerSubAgent = subAgent.toLowerCase()

  if (lowerSubAgent.includes('paga')) return 'Paga Ghana'
  if (lowerSubAgent.includes('moneygram')) return 'MoneyGram Nigeria'
  if (lowerSubAgent.includes('worldremit')) return 'WorldRemit Kenya'
  if (lowerSubAgent.includes('flutterwave') && lowerSubAgent.includes('ghana'))
    return 'Flutterwave Ghana'
  if (lowerSubAgent.includes('flutterwave')) return 'Flutterwave Nigeria'
  if (lowerSubAgent.includes('mpesa') || lowerSubAgent.includes('m-pesa'))
    return 'M-Pesa Kenya'
  if (lowerSubAgent.includes('orange')) return 'Orange Money Senegal'
  if (lowerSubAgent.includes('accra')) return 'Accra Money Center'
  if (lowerSubAgent.includes('lagos')) return 'Lagos Express'
  if (lowerSubAgent.includes('nairobi')) return 'Nairobi Remit Center'
  if (lowerSubAgent.includes('ghana')) return 'Paga Ghana'
  if (lowerSubAgent.includes('nigeria')) return 'MoneyGram Nigeria'
  if (lowerSubAgent.includes('kenya')) return 'WorldRemit Kenya'
  if (lowerSubAgent.includes('senegal')) return 'Orange Money Senegal'

  // Default to first option if no match
  return VALID_SUB_AGENTS[0]
}
